import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ImportKind, ImportOnExisting } from '@nucleus-commerce/api-client/admin';

import { importsApi } from '../api/imports-api';

import { jobKeys } from './job-keys';

/** 202 with a queued job; file refusals (422/413/415) are rendered on the file field. */
export function useCreateImport(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      kind,
      file,
      onExisting,
    }: {
      kind: ImportKind;
      file: File;
      onExisting?: ImportOnExisting | undefined;
    }) => importsApi.create(storeId, kind, file, onExisting),
    meta: { successMessage: 'importsExports:toasts.importStarted', silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: jobKeys.imports(storeId) }),
  });
}
